import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const languages = [
    { id: "en", title: "English", subtitle: "English" },
    { id: "hi", title: "हिंदी", subtitle: "Hindi" },
    { id: "mr", title: "मराठी", subtitle: "Marathi" },
    { id: "kn", title: "ಕನ್ನಡ", subtitle: "Kannada" },
    // Add more languages as needed
];

export default function LanguageSelectionPage() {
    const [selectedLang, setSelectedLang] = useState("en");
    const navigate = useNavigate();

    const handleConfirm = () => {
        // console.log("Language selected:", selectedLang);
        navigate('/selectLocationToWork')
        // proceed to next step or save selection
    };

    return (
        <div className="font-satoshi min-h-[100dvh] bg-black text-white flex flex-col ">
            {/* Image Section */}
            <div className="relative w-full  flex-1 ">
                <img
                    src="https://media.istockphoto.com/id/1440702287/photo/workers-in-a-factory-making-roof-sheets.jpg?s=1024x1024&w=is&k=20&c=HAkMe4btGUmQReFsqOgG-n5LvDQwraBj7aAfLPrRWCg=" // Replace with your image path or import
                    alt="Swiggy partner"
                    className="w-full h-full object-cover"
                />
                {/* Top Welcome Section */}
                <div className="  absolute top-8 left-0 w-full text-center z-10 bg-[radial-gradient(white, transparent)]">
                    <h1 className="text-2xl text-[#00bdff] font-bold">Hello Partner!</h1>
                    <p className=" text-[#00bdff] text-md">Welcome to Claimpro</p>
                </div>
            </div>


            {/* Language Selection Section */}
            <div className="bg-white w-full rounded-t-3xl px-6 pt-6 pb-[1.5rem] text-black">
                <h2 className="text-md font-semibold mb-4">Select a language to continue</h2>

                <div className="grid grid-cols-2 gap-[0.5rem]">
                    {languages.map((lang) => (
                        <label
                            key={lang.id}
                            className={`border rounded-xl p-[1rem] flex flex-col justify-center items-start cursor-pointer relative ${selectedLang === lang.id ? "border-[#8ccded]" : "border-gray-300"
                                }`}
                        >
                            <input
                                type="radio"
                                name="language"
                                value={lang.id}
                                checked={selectedLang === lang.id}
                                onChange={() => setSelectedLang(lang.id)}
                                className="absolute top-3 right-3 accent-[#8ccded]"
                            />
                            <span className="text-md font-bold">{lang.title}</span>
                            <span className="text-sm text-gray-500">{lang.subtitle}</span>
                        </label>
                    ))}
                </div>

                <button
                    onClick={handleConfirm}
                    className="mt-8 w-full bg-[#00bdff] text-white py-3 rounded-xl font-semibold text-lg"
                >
                    Confirm
                </button>
            </div>
        </div>
    );
}
